import styles from "./styles/FoodItem.scss";

export const getItemPriceClassName = (showInputQtyField: boolean | undefined) => {
    return showInputQtyField ? styles.qtyInputPriceContainer : undefined;
};
